module.exports = __webpack_public_path__ + "assets/asian_active-b85f2b.svg";